import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export function useDisputesLeaderboard(range = '90d', limit = 10) {
  return useQuery({
    queryKey: ['admin', 'disputes', 'leaderboard', range, limit],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const { data } = await axios.get(
        `${API_BASE}/api/admin/disputes/leaderboard?range=${range}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
